import { render } from "./AboutUsDesc.vue?vue&type=template&id=3b806268&scoped=true"
import script from "./AboutUsDesc.vue?vue&type=script&lang=js"
export * from "./AboutUsDesc.vue?vue&type=script&lang=js"

import "./AboutUsDesc.vue?vue&type=style&index=0&id=3b806268&scoped=true&lang=css"

import exportComponent from "/mnt/data/workspace/risetai/riset.ai-website/Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b806268"]])

export default __exports__